import {Observable} from 'rxjs/Observable';
import {element} from 'protractor';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';

import {environment} from '../../../environments/environment';
import {SessionService} from './../session/session.service';
import {ProcessoService} from './../processo/processo.service';
import {ProcessoSeletivo} from './../processo/processo-seletivo';
import {HeaderService} from './../http/header.service';

@Injectable()
export class CursosService {

    constructor(private http: Http,
                private SessionService: SessionService,
                private ProcessoService: ProcessoService,
                private HeaderService: HeaderService) {
    }

    carregaCursos(): Observable<any> {

        let PrcTipPrc = this.SessionService.getValor("PrcTipPrc"); //Chamado 560376 - Rafael dos Santos - 16/08/2024

        // Por algum motivo, começou a gerar erro nessa parte, ao invés de enviar vazio como parâmetro, estava enviando null e o DP não considerava como vazio
        if (PrcTipPrc === null || PrcTipPrc === undefined) {
            PrcTipPrc = "";
        }

        return this.http
            .get(environment.apiGxUrl + `/dpprocseletivoscursos.svc/rest/?PrcTipPrc=${PrcTipPrc}`) //Chamado 560376 - Rafael dos Santos - 16/08/2024: Adicionada variável PrcTipPrc na chamada
            .map(res => res.json())
            .catch((err: any) => {
                return Observable.throw(err.json());
            });
    }

	carregaLinkEdital(): Observable<any> {
		const processo_selecionado =
      		this.ProcessoService.getProcessoSeletivoSelecionado();

		return this.http
		.get(environment.apiGxUrl + "/dpproceditalseletivo.svc/rest/", {
			params: {
			PrcLetAno: processo_selecionado.PrcLetAno,
			PrcLetSem: processo_selecionado.PrcLetSem,
			PrcTipCod: processo_selecionado.PrcTipCod,
			PrcOcoSeq: this.ProcessoService.getOcorrencia(),
			},
		})
		.map((res) => res.json())
		.catch((err: any) => {
			return Observable.throw(err.json());
		});
	}

    setCursos(json) {

        let processo = this.ProcessoService.getProcessoSeletivo();
        if (!processo) {
            processo = new ProcessoSeletivo();
        }

        processo.TipoProcesso = json[0]['TipoProcesso'];

        return this.getCursoProcessoSeletivo(processo);
    }

    getCursoProcessoSeletivo(processo) {
        let documentos = {};
        let documentosComplementares = {};
        const cursos = [];

        //Incluir filtro de ano aqui - DEBUG RAFAEL
        processo.TipoProcesso.forEach(Tipo => {

            Tipo.Ocorrencia.forEach(ocorrencia => {

                let PrcTipPrc = sessionStorage.getItem("PrcTipPrc");

                if (!this.ProcessoService.getTipoProcesso()) {
                    this.ProcessoService.setTipoProcesso(Tipo.PrcTipCod);
                }

                if (!this.ProcessoService.getPrcLetAno()){
                    this.ProcessoService.setPrcLetAno(Tipo.PrcLetAno);
                }

                if (!this.ProcessoService.getPrcLetSem()){
                    this.ProcessoService.setPrcLetSem(Tipo.PrcLetSem);
                }

                if (!this.ProcessoService.getOcorrencia()) {
                    this.ProcessoService.setOcorrencia(ocorrencia.PrcOcoSeq);
                }

                documentos = Object.assign(documentos, ocorrencia.DocumentosOcorrencia);

                documentosComplementares = Object.assign(documentosComplementares, ocorrencia.PrcCriterios);

                const processoId = Tipo.PrcTipCod + '-' + ocorrencia.PrcOcoSeq + '-' + Tipo.PrcLetAno + '-' + Tipo.PrcLetSem;

                if (processo.Processos.findIndex(p => p.id === processoId) == -1) {

                    processo.Processos.push(
                        {
                            id: processoId,
                            text: ocorrencia.PrcNom,
                            PrcLetAno: Tipo.PrcLetAno,
                            PrcLetSem: Tipo.PrcLetSem,
                        }
                    );
                }

                if (PrcTipPrc == "G" || PrcTipPrc == null || typeof PrcTipPrc == "undefined"){
                  if (this.ProcessoService.getTipoProcesso() == Tipo.PrcTipCod && this.ProcessoService.getOcorrencia() == ocorrencia.PrcOcoSeq) {
                      ocorrencia.PrcOferecimento.forEach(element => {

                          const curso = this.capitalizeCurso(this.removeAccentos(element.PrcOfeCurNom.toLowerCase()));

                          if (!cursos[curso]) {
                              cursos[curso] = [];
                          }

                          if (!cursos[curso][element.CamNom]) {
                              cursos[curso][element.CamNom] = [];
                          }

                          // if (!cursos[curso][element.CamNom][element.TnoDes]) {
                          cursos[curso][element.CamNom][element.TnoDes] = element;
                          cursos[curso][element.CamNom][element.TnoDes].PrcOcoSeq = ocorrencia.PrcOcoSeq;
                          // }

                      });
                  }
                }else{
                  if (this.ProcessoService.getTipoProcesso() == Tipo.PrcTipCod && this.ProcessoService.getOcorrencia() == ocorrencia.PrcOcoSeq && this.ProcessoService.getPrcLetAno() == Tipo.PrcLetAno && this.ProcessoService.getPrcLetSem() == Tipo.PrcLetSem) {
                    ocorrencia.PrcOferecimento.forEach(element => {

                        const curso = this.capitalizeCurso(this.removeAccentos(element.PrcOfeCurNom.toLowerCase()));

                        if (!cursos[curso]) {
                            cursos[curso] = [];
                        }

                        if (!cursos[curso][element.CamNom]) {
                            cursos[curso][element.CamNom] = [];
                        }

                        // if (!cursos[curso][element.CamNom][element.TnoDes]) {
                        cursos[curso][element.CamNom][element.TnoDes] = element;
                        cursos[curso][element.CamNom][element.TnoDes].PrcOcoSeq = ocorrencia.PrcOcoSeq;
                        // }

                    });
                  }
                }

            });
        });

        this.ProcessoService.setProcessoSeletivo(processo);

        return cursos;
    }

    removeAccentos(string: string) {
        return string
            .replace(/á/g, 'a')
            .replace(/é/g, 'e')
            .replace(/í/g, 'i')
            .replace(/ó/g, 'o')
            .replace(/ú/g, 'u');
    }

    capitalizeCurso(string) {
        const splitted = string.split(' ');
        let elemento;
        for (let index = 0; index < splitted.length; index++) {
            if (elemento) {
                if (splitted[index].length > 2) {
                    elemento = elemento + ' ' + splitted[index].charAt(0).toUpperCase() + splitted[index].slice(1);
                } else {
                    elemento = elemento + ' ' + splitted[index];
                }
            } else {
                if (splitted[index].length > 2) {
                    elemento = splitted[index].charAt(0).toUpperCase() + splitted[index].slice(1);
                } else {
                    elemento = splitted[index];
                }
            }
        }
        return elemento;
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/curso/cursos.service.ts